import React from 'react';
import QuantityInput from '../../../Components/QuantityInput';

interface AttributeRow {
  attributeName: string;
  count: number;
}

interface AttributeCountTableProps {
  data: AttributeRow[];
  setData: (data: AttributeRow[]) => void;
}

const AttributeCountTable: React.FC<AttributeCountTableProps> = ({ data, setData }) => {

    const getDefaultVal = (name: string) => {
        if (name === "Tire Thread Depth") return 2;
        if (name === "Brakes") return 1;
        return 0;
    };

    const handleInputChange = (index: number, field: keyof AttributeRow, value: string | number) => {
        const newData = [...data];
        if (field === 'count') {
            newData[index] = { ...newData[index], count: value as number };
        } else {
            newData[index] = { ...newData[index], [field]: value as string };
        }
        setData(newData);
    };

    return (
        <div className={`col-8 mt-3`}>
            {/* <h5 className="fw-bold">Add Attributes</h5> */}
            <table className="table table-bordered">
                <thead className="table-light">
                    <tr>
                        <th scope="col">Attribute Name</th>
                        <th scope="col" style={{ width: '30%' }}>Count</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, index) => (
                        <tr key={index}>
                            <td className="p-0">
                                <input
                                    type="text"
                                    className="form-control border-0"
                                    value={row.attributeName}
                                    disabled
                                    onChange={(e) => handleInputChange(index, 'attributeName', e.target.value)}
                                />
                            </td>
                            <td className="p-0">
                                {/* <QuantityInput
                                    value={row.count}
                                    onChange={(val) => handleInputChange(index, 'count', val)}
                                    min={getDefaultVal(row.attributeName)}
                                /> */}
                                <input
                                    type="number"
                                    className="form-control border-0"
                                    value={row.count}
                                    disabled
                                    onChange={(e) => handleInputChange(index, 'count', e.target.value)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AttributeCountTable;
